<template>
  <div class="login-con">
    <div class="login-center" />
    <div class="login-logo" />

    <div class="login-form-div">
      <div class="div-language">
        <lang-select :size="'medium'" style="color: #00c4ff;" />
      </div>
      <div class="login-div login-user">
        <el-form ref="form1" :model="loginForm" :rules="rules">
          <el-form-item prop="username">
            <el-input
              v-model="loginForm.username"
              size="large"
              clearable
              :placeholder="$t('login.userPlaceholder')"
            >
              <div slot="prefix" class="prefix-left">
                <!-- <svg-icon icon-class="icon-login-user" /> -->
                <img src="../../assets/images/icon_user.png" alt="">
              </div>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="login-div login-login">
        <el-form ref="form2" :model="loginForm" :rules="rules" @submit.native.prevent>
          <el-form-item prop="password">
            <el-input
              v-model="loginForm.password"
              size="large"
              clearable
              type="password"
              show-password
              :placeholder="$t('login.pwdPlaceholder')"
              @keyup.enter.native="login"
            >
              <div slot="prefix" class="prefix-left">
                 <img src="../../assets/images/icon_password.png" alt="">
              </div>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <!-- <div class="login-div" style="position:relative">
        <div class="code-mask" v-show="(!loginForm.username || !loginForm.password)"></div>
      </div> -->

      <div class="login-div login-button">
        <el-button
          :class=" (!loginForm.username || !loginForm.password) ? 'login-button-ban':''"
          type="success"
          :loading="loading"
          size="large"
          round
          @click="login"
        >
          {{ $t('login.login') }}
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import LangSelect from '@/components/LangSelect'
export default {
  name: 'Login',
  components: { LangSelect },
  data() {
    const validatelUseName = (rule, value, cb) => {
      if (!value) {
        return cb(new Error(this.$t('login.userError')))
      }
    }
    const validatelPwd = (rule, value, cb) => {
      if (!value) {
        return cb(new Error(this.$t('login.pwdError')))
      }
    }
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loading: false,
      rules: {
        username: [
          { required: true, trigger: ['blur', 'change'], validator: validatelUseName }
        ],
        password: [
          { required: true, trigger: ['blur', 'change'], validator: validatelPwd }
        ]
      },
      formList: ['form1', 'form2']

    }
  },
  methods: {
    login() {
      if (!this.loginForm.username || !this.loginForm.password) {
        return
      }
      this.loading = true
      this.$store.dispatch('login', this.loginForm).then(() => {
        this.loading = false
        this.$router.push({ name: 'home' })
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss">
  $input_color: #00c4ff;
  $input_bg: rgb(17,51,123,.9);
  $input_boder_color: rgba(0,196,255,.9);
  .login-con *{
    font-size: 12px;
  }
  .login-con{
    width: 100%;
    max-height: 100%;
    min-height: 100%;
    background:  url(../../assets/images/bg_login.png) no-repeat;
    background-size: 100% 100%;
    position: absolute;
    .login-center{
      width: 100%;
      height: 75vh;
      background:  url(../../assets/images/img_mid.png) no-repeat;
      background-size: 73% 100%;
      background-position: 15vw center;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin:  auto;
    }
    .el-input__icon{
      color: $input_color !important;
    }
    input::-webkit-input-placeholder{
      color:$input_color !important;
     }
    input::-moz-placeholder{   /* Mozilla Firefox 19+ */
      color:$input_color !important;
    }
    input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
        color:$input_color !important;
    }
    input:-ms-input-placeholder{  /* Internet Explorer 10-11 */ 
        color:$input_color !important;
    }
  }
  .login-logo{
    width: 400px;
    height: 40px;
    position: absolute;
    top:5vh;
    left: 4%;
    background: url(../../assets/images/logo-v2x.png) no-repeat;
    background-size: contain;
  }
  .login-form-div{
    width: 100%;
    height: 60px;
    position: absolute;
    bottom: 60px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    .div-language{
      margin-top:10px
    }
    .login-div{
      &.login-login{
        padding: 0 30px;
      }
    .el-input {
      display: inline-block;
      width: 250px;
    
      input {
        background-color: $input_bg;
        border-color:  $input_boder_color !important;
        border: 0px;
        -webkit-appearance: none;
        border-radius:0;
        color: $input_color;
      }
      &.el-input--large .el-input__inner{
        padding-left: 50px;
        border-radius: 20px;
        border: 1px solid rgb(37,110,149);

      }
      .prefix-left{
        text-align:center;
        line-height:38px;
        width: 38px;
        height: 38px;
        position: relative;
        // border-radius:50%;
        // border: 1px solid rgb(37,110,149);
        margin-top: 1px;
        margin-left: -4px;
        display: flex;
        justify-content: center;
        align-items: center;
        img{
          width: 20px;
          height: 20px;
        }
        &::after{
          content: "";
          width: 2px;
          height: 22px;
          background: url(../../assets/images/img_line.png) no-repeat;
          background-size: contain;
          position: absolute;
          left: 36px;
        }

      }
    }
    .el-form-item.is-error .el-input input.el-input__inner{
      border-color: red !important;
      .prefix-left{

        border-left-color: red !important;
        // border-left-color: red;

      }
    }
    .el-form-item__error{
      color: red !important
    }
    .el-button{
      &.el-button--success.el-button--large{
        background:  $input_bg;
        border-color: $input_boder_color;
        color: $input_color;
        padding-left: 30px;
        padding-right: 30px;
        &:hover{
          background: linear-gradient(to bottom, #4EC8F5, #0D81F3);
           color: #fff;
        }
        &.is-loading{
          background: linear-gradient(to bottom, #4EC8F5, #0D81F3);
          color: #fff;
        }
      }
    }
    .login-button-ban{
      border-color:  $input_boder_color;
      &.el-button--success.el-button--large{
        &:hover{
          cursor:not-allowed;
          // background: transparent;
        }
        
      }
    }
    }
    }
    
</style>

